import { IMDSCalendarCellProps } from "./calendar-cell.types";
import { StyledCalendarCell } from "./calendar-cell.style";

export function MDSCalendarCell(props: IMDSCalendarCellProps) {
  return <StyledCalendarCell {...props} />;
}
